import {
	server_result,
	inbigwin,
	inmoneyadd,
	picture_convert,
	set_inanim, set_inwincount, states
} from "../framework/src/engine/madnes/madnes_variables";
import {
	madnes_get_dimension_he,
	madnes_get_dimension_wi,
	madnes_get_pos_x, madnes_get_pos_y,
	madnes_get_texture,
	madnes_get_visible,
	madnes_set_alpha,
	madnes_set_cstm_val, madnes_set_img_center, madnes_set_pos, madnes_set_pos_x, madnes_set_pos_y, madnes_set_texture,
	madnes_set_visible, madnes_sprite_set_frame
} from "../framework/src/engine/madnes/madnes_object";
import {arrow_show_7, arrow_show_81, clear_winframes, hide_arrows} from "./j81_reels";
import {madnes_add_win, madnes_win_anim_reset, madnes_win_anim_skip} from "../framework/src/engine/madnes/madnes";
import {money_add_control} from "./j81_end_ctrl";
import {AnimFade} from "./j81_extanims";
import {madnes_audio_play} from "../framework/src/engine/madnes/madnes_audio";
import {anims_scale_symbols, madnes_fade_in, madnes_fade_out} from "./j81_anims";
import {STATES} from "../framework/src/states/states";

var spin_win = 0;

// Zacatek kontroly vyher
var result_control_pos = 0;

export function result_control0() {
	hide_arrows();
	if(detect_joker(server_result.result.reelMatrix)) {
		arrow_show_81(true);
	} else {
		arrow_show_7();
	}

	setTimeout(result_control, server_result.result.lineWins ? 800 : 0);
}

export function result_control()
{
	spin_win = 0;

	if(inmoneyadd || inbigwin)
	{
		setTimeout(result_control, 100);
		return;
	}

	set_inanim(1);
	result_control_pos = 0;

	result_control_part();

}

// kontrola vyhry na aktualni pozici
async function result_control_part()
{
	var lw = server_result.result.lineWins;

	if(lw == null || lw[result_control_pos] == null)
	{
		madnes_win_anim_reset();

		set_orig_textures(function ()
		{
			money_add_control();
		});

		if(lw != null)
		{
			set_inwincount(false);
		}
	}
	else
	{
		states.setState(STATES.SKIP);

		if(madnes_win_anim_skip()) {
			//if(
			//	server_result.result.lineWins[result_control_pos].type == "wild" ||
			//	server_result.result.lineWins[result_control_pos].type == "normal"
			//) {
				if(typeof lw[result_control_pos]['win'] != "undefined")
				{
					await madnes_add_win(lw[result_control_pos]['win'] * 1); // win = win * 1 + lw[result_control_pos]['win'] * 1;
					spin_win = spin_win * 1 + lw[result_control_pos]['win'] * 1;
				}

				result_control_pos++;
				result_control_part();
			//} else {
			//	result_control_part_proc(server_result.result.lineWins[result_control_pos]);
			//}
		} else {
			result_control_part_proc(lw);
		}
	}
}

function set_orig_textures(callback)
{
	var proms = [];

	for(var i in server_result.result.reelMatrix[0])
	{
		for(var j in server_result.result.reelMatrix[0][i])
		{
			var symNum = server_result.result.reelMatrix[0][i][j];
			var symb = "reels_bufer_" + i + "_S" + (2 - j);

			madnes_set_cstm_val(symb, '');

			if(picture_convert[symNum] != madnes_get_texture(symb))
			{
				var p = anim_change_symbol(symb, symNum);
				proms.push(p);
			}
		}
	}

	Promise.all(proms).then(callback);
}

/**
 * @param {string} symb
 * @param {number} symNum
 * @returns {Promise}
 */
function anim_change_symbol(symb, symNum)
{
	console.log(symb, symNum);

	var animFadeOut = new AnimFade('out', symb, 100);
	var animFadeIn = new AnimFade('in', symb, 90);

	return animFadeOut.run().then(function() {

		madnes_set_texture(symb, picture_convert[symNum]);
		madnes_sprite_set_frame(symb, 1);

		return animFadeIn.run();
	});

}

function result_add_win(win_set) {
	madnes_add_win(win_set['win'] * 1); // win = win*1 + win_set['win'] * 1;
	spin_win = spin_win*1 + win_set['win'] * 1;
}

function result_control_part_proc(lineWins)
{
	var win_set = lineWins[result_control_pos];

	set_inwincount(true);;
	var linenum = 0;

	if(typeof win_set["line"] != "undefined" && win_set["line"] != null && win_set["line"] >= 0)
	{
		linenum = 1;
	}

	show_winline(win_set["line"]);

	madnes_audio_play("win_" + picture_convert[win_set["symbol"]]);

	if(linenum != 0)
	{
		// madnes_win_anim_add();

		result_add_win(win_set);
		result_control_part_win(lineWins, result_control_pos);

	} else {
		result_control_next();
	}
}

function set_symbol_center(symbName)
{
	madnes_set_img_center(symbName, 0.5, 0.5);
	madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) + madnes_get_dimension_wi(symbName) / 2);
	madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) + madnes_get_dimension_he(symbName) / 2);
}

function set_symbol_center_top_left(symbName)
{
	madnes_set_img_center(symbName, 0, 0);
	madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) - madnes_get_dimension_wi(symbName) / 2);
	madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) - madnes_get_dimension_he(symbName) / 2);
}


function result_control_next()
{
	result_control_pos++;
	result_control_part();
}

function get_symbol_name(i) {
	return picture_convert[i];
}

function get_symbols_from_winset(win_set) {

	var symbols = [];

	for(var pos in win_set["position"]) {
		var xPos = win_set["position"][pos][0];
		var yPos = win_set["position"][pos][1];
		var yPosS = 2 - yPos;

		var symbolName = get_symbol_name(server_result["result"]["reelMatrix"][0][xPos][yPos]);
		var symbObj = {
			'spriteName': "reels_bufer_" + xPos + "_S" + yPosS,
			'tmpSpriteName': "reels_bufer_" + xPos + "_TMP" + yPosS,
			'symbolName': symbolName,
			'x': xPos,
			'y': yPosS,
			'posX': madnes_get_pos_x("reels_bufer_" + xPos + "_S" + yPosS),
			'posY': madnes_get_pos_y("reels_bufer_" + xPos + "_S" + yPosS),
			'isJoker': symbolName === "symbol_Joker"
		};

		symbols.push(symbObj);
	}

	return symbols;

}

function set_tmp_symbols(symbols, win_set) {

	for(var i in symbols) {

		var symbol = symbols[i];

		var symbolName = picture_convert[win_set['symbol']]; //symbol['symbolName'];
		var spriteName = symbol['spriteName'];
		var posX = symbol['posX'];
		var posY = symbol['posY'];
		var tmpSpriteName = symbol['tmpSpriteName'];

		madnes_set_texture(tmpSpriteName, symbolName);
		madnes_sprite_set_frame(tmpSpriteName, 1);
		madnes_set_pos(tmpSpriteName, posX, posY);
		madnes_set_img_center(tmpSpriteName, 0.5, 0.5);

		madnes_set_cstm_val(spriteName, symbols[i]['isJoker'] ? true : false);

		madnes_set_visible(spriteName, false);
		madnes_set_visible(tmpSpriteName, true);

		madnes_set_pos("win_frame_" + symbol['x'] + "_" + symbol['y'], posX, posY);
		madnes_set_visible("win_frame_" + symbol['x'] + "_" + symbol['y'], true);
	}
}

function unset_tmp_symbols(symbols) {

	for(var i in symbols) {

		var symbol = symbols[i];

		madnes_set_texture(symbol['tmpSpriteName'], null);
		madnes_set_visible(symbol['tmpSpriteName'], false);

		madnes_set_visible(symbol['spriteName'], true);
	}
}

function is_symbol_in_next_winline(symbol, lineWins, controlPos) {

	if(typeof lineWins[controlPos + 1] !== 'undefined') {

		var win_set = lineWins[controlPos + 1];
		var nextSymbols = get_symbols_from_winset(win_set);

		for(var i in nextSymbols) {

			var nSymb = nextSymbols[i];

			if(
				nSymb['spriteName'] === symbol['spriteName'] &&
				nSymb['symbolName'] === symbol['symbolName']
			) {
				return true;
			}
		}
	}

	return false;
}



function result_control_part_win(lineWins, controlPos)
{
	var win_set = lineWins[controlPos];

	var symbols = get_symbols_from_winset(win_set);

	set_tmp_symbols(symbols, win_set);

	//setTimeout(function() {

		anims_scale_symbols(symbols).then(function() {

			setTimeout(function() {

				unset_tmp_symbols(symbols);

				hide_winline(win_set.line);
				clear_winframes();

				result_control_part_proc_nxt();

			}, 1100);
		});
	//}, 0);
}

function result_control_part_proc_nxt()
{
	result_control_pos++;
	result_control_part();
}

function is_next_same_win_symbol()
{
	if(typeof server_result.result.lineWins[result_control_pos * 1 + 1] === 'undefined') {
		return false;
	}

	return server_result.result.lineWins[result_control_pos * 1 + 1]['symbol'] == server_result.result.lineWins[result_control_pos * 1]['symbol'];
}

function is_center_win_line(winset)
{
	return (winset.line == 13);
}

function get_symbol_on_position(x, y)
{
	var sNum = server_result.result.reelMatrix[0][x][y];
	return picture_convert[sNum];
}

function is_joker_in_reel(reel) {

	var jokerIndex = picture_convert.indexOf('symbol_Joker');

	if(typeof reel == 'object' && jokerIndex >= 0) {
		return reel.indexOf(jokerIndex) >= 0 ? true : false;
	}

	return false;
}

function show_all_lines()
{
	var res = {};

	if(!server_result || typeof server_result.result == 'undefined') {
		res = [server_config.matrix.reelMatrix];
	} else {
		res = server_result.result.reelMatrix;
	}

	if(detect_joker(res))
	{
		madnes_set_visible("winlines81", true);
		madnes_set_alpha("winlines81", 0);

		madnes_fade_in("winlines81", 200, 0);

	}
	else
	{
		madnes_set_visible("winlines7", true);
		madnes_set_alpha("winlines7", 0);

		madnes_fade_in("winlines7", 200, 0);
	}
}

export function hide_all_lines()
{
	if(madnes_get_visible("winlines81"))
	{
		madnes_fade_out("winlines81", 400, 0, function() {
			madnes_set_alpha("winlines81", 1);
			madnes_set_visible("winlines81", false);
		});
	}

	if(madnes_get_visible("winlines7"))
	{
		madnes_fade_out("winlines7", 400, 0, function() {
			madnes_set_alpha("winlines7", 1);
			madnes_set_visible("winlines7", false);
		});
	}
}

function betmenu_open()
{
	show_all_lines();
}

export function detect_joker(reelMatrix)
{
	for(var i in reelMatrix[0])
	{
		for(var j in reelMatrix[0][i])
		{
			var symNum = reelMatrix[0][i][j];

			if(picture_convert[symNum] == 'symbol_Joker') {
				return true;
			}
		}
	}

	return false;
}

function show_winline(lineNum)
{
	if(detect_joker(server_result.result.reelMatrix))
	{
		lineNum = lineNum * 1 + 1;
		madnes_set_visible("winline81_" + lineNum, true);
	}
	else
	{
		madnes_set_visible("winline7_" + lineNum, true);
	}
}

function hide_winline(lineNum)
{
	if(detect_joker(server_result.result.reelMatrix))
	{
		lineNum = lineNum * 1 + 1;
		madnes_set_visible("winline81_" + lineNum, false);
	}
	else
	{
		madnes_set_visible("winline7_" + lineNum, false);
	}
}